import RadioGroup from "../inputs/RadioGroup";
import TextInput from "../inputs/TextInput";
import { CombinedInputFieldsetPropsDTT } from "./FieldsetProps";
import { RadioButtonField, TextInputField } from "../inputs/InputProps";

import "./Fieldset.scss";

const DocumentTransferTax: React.FC<CombinedInputFieldsetPropsDTT> = ({
    currentSelection,
    setCurrentSelection,
    areaSelection,
    setAreaSelection,
    textInputValue,
    setInputValue,
    fieldsetLabel,
}) => {
    const radioFields: RadioButtonField[] = [
        {
            id: "0",
            label: "Yes, documentary transfer tax is applicable.",
        },
        {
            id: "1",
            label: "No, documentary transfer tax is not applicable.",
        },
    ];

    const textField: TextInputField = {
        id: "2",
        labelHidden: false,
        label: "Selling price (no commas or dollar sign; cents required, i.e. 152645.00)",
        type: "number",
        min: "0.00",
        max: "999999999999999",
        step: "0.01",
        boldLabel: true,
    };

    const areaFields: RadioButtonField[] = [
        {
            id: "Unincorporated",
            label: "Unincorporated Area",
        },
        {
            id: "Santa Rosa",
            label: "City of Santa Rosa",
        },
        {
            id: "Petaluma",
            label: "City of Petaluma",
        },
        {
            id: "Other",
            label: "Other City",
            subLabel: "Includes Cloverdale, Cotati, Healdsburg, Rohnert Park, Sebastopol, Sonoma and Town of Windsor",
        },
    ];

    const formatCurrencyInput = (value: string): void => {
        const price = Number(value);
        if (!isNaN(price)) {
            setInputValue(price.toFixed(2));
        } else {
            setInputValue("0.00");
        }
    };

    return (
        <fieldset className="fee-calc-fieldset">
            <legend>
                <i className="fa fa-asterisk" aria-hidden="true" title="Required"></i>
                <span className="sr-only">Required</span>
                {fieldsetLabel ? (
                    <>
                        Documentary Transfer Tax (<abbr title="Documentary Transfer Tax">DTT</abbr>) is applicable when{" "}
                        {fieldsetLabel}
                    </>
                ) : (
                    <>
                        Documentary Transfer Tax (<abbr title="Documentary Transfer Tax">DTT</abbr>) is applicable when
                        any lands, tenements or other realty is sold within the county and when the consideration or
                        value of the sale exceeds one hundred dollars ($100)
                    </>
                )}{" "}
                (
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://leginfo.legislature.ca.gov/faces/codes_displaySection.xhtml?sectionNum=11911.&lawCode=RTC"
                >
                    <abbr title="Revenue and Taxation Code">RTC</abbr>11911
                </a>
                ).
            </legend>
            <RadioGroup
                currentSelection={currentSelection}
                setCurrentSelection={setCurrentSelection}
                fieldsetId="DocumentTransferTax"
                fields={radioFields}
            />
            {currentSelection === "0" && (
                <fieldset className="fee-calc-fieldset no-border">
                    <legend>
                        <i className="fa fa-asterisk" aria-hidden="true" title="Required"></i>
                        <span className="sr-only">Required</span>
                        Indicate where the land, tenement or other realty is located. This location will be described in
                        the <abbr title="Documentary Transfer Tax">DTT</abbr> Declaration area:
                    </legend>
                    <RadioGroup
                        currentSelection={areaSelection}
                        setCurrentSelection={setAreaSelection}
                        fieldsetId="DocumentTransferTax_City"
                        fields={areaFields}
                    />
                    <TextInput
                        value={textInputValue}
                        handleFieldChange={setInputValue}
                        fieldsetId="DocumentTransferTax"
                        field={textField}
                        onBlur={formatCurrencyInput}
                    />
                </fieldset>
            )}
            {currentSelection === "1" && (
                <p className="sub-legend">
                    If there is no Documentary Transfer Tax being declared, your document must include a valid exemption
                    to paying <abbr title="Documentary Transfer Tax">DTT</abbr>. Valid exemptions may be located in{" "}
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://leginfo.legislature.ca.gov/faces/codes_displayText.xhtml?lawCode=RTC&division=2.&title=&part=6.7.&chapter=3.&article="
                    >
                        RTC[11921-11930]
                    </a>
                    .
                </p>
            )}
        </fieldset>
    );
};

export default DocumentTransferTax;
